/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type MemoryStoreDeleted = {
  id: string;
  object: "memory_store.deleted";
  deleted: boolean;
};

/** @internal */
export const MemoryStoreDeleted$inboundSchema: z.ZodType<
  MemoryStoreDeleted,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  object: z.literal("memory_store.deleted"),
  deleted: z.boolean(),
});
/** @internal */
export type MemoryStoreDeleted$Outbound = {
  id: string;
  object: "memory_store.deleted";
  deleted: boolean;
};

/** @internal */
export const MemoryStoreDeleted$outboundSchema: z.ZodType<
  MemoryStoreDeleted$Outbound,
  z.ZodTypeDef,
  MemoryStoreDeleted
> = z.object({
  id: z.string(),
  object: z.literal("memory_store.deleted"),
  deleted: z.boolean(),
});

export function memoryStoreDeletedToJSON(
  memoryStoreDeleted: MemoryStoreDeleted,
): string {
  return JSON.stringify(
    MemoryStoreDeleted$outboundSchema.parse(memoryStoreDeleted),
  );
}
export function memoryStoreDeletedFromJSON(
  jsonString: string,
): SafeParseResult<MemoryStoreDeleted, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MemoryStoreDeleted$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MemoryStoreDeleted' from JSON`,
  );
}
